import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const autoExpandSelectionRangeOnInlineNodePluginKey = new PluginKey(
	'autoExpandSelectionRangeOnInlineNodePlugin',
);
